// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/css/animate.css
// module id = 1306
// module chunks = 0